import { createUseFetch } from 'api/common/createUseFetch'
import { fetchPageBuilderAsset } from 'api/pageBuilder/fetchers/fetchPageBuilderAssest'
import { ApiQueryKeys } from 'constants/apiQueryKeys'

export const useFetchPageBuilderAssetApi = createUseFetch({
  queryKey: ApiQueryKeys.PAGE_BUILDER_ASSET,
  fetcher: fetchPageBuilderAsset,
})
